export default __webpack_public_path__ + "static/wwc-image4-9485aeb11406c3da0c331ecebfb98522.jpg";